import deepmerge from "deepmerge";
import { RemoteStore } from "./stores/remote";
import { LocalStore } from "./stores/local";
import { logStatus } from "../utils";
export class DistributedStoreClientImpl {
    constructor(gluePromise, asyncConstructors, loggerClient) {
        this.gluePromise = gluePromise;
        this.asyncConstructors = asyncConstructors;
        this.loggerClient = loggerClient;
        this.localStores = {};
        const pw = asyncConstructors.addConstructor();
        gluePromise.then((g) => {
            this.glue = g;
            asyncConstructors.finishConstructor(pw);
        });
    }
    logStatus(method, type, data) {
        logStatus(this.loggerClient, this.glue, {
            api: "DistributedStore",
            method, type, data
        });
    }
    async createStore(params, cb) {
        this.logStatus("createStore", "start", params);
        await this.asyncConstructors.ready();
        const data = await this.getOrCreateStoreObject(params);
        this.logStatus("createStore", "return", { err: null, data });
        cb?.(null, data);
        return { err: null, data };
    }
    async getStore(params, cb) {
        this.logStatus("getStore", "start", params);
        await this.asyncConstructors.ready();
        const store = await this.getOrCreateStoreObject(params);
        this.logStatus("getStore", "return", { err: null, data: store });
        cb?.(null, store);
        return {
            err: null,
            data: store,
        };
    }
    async removeStore(params, cb) {
        this.logStatus("removeStore", "start", params);
        await this.asyncConstructors.ready();
        let foundLocal = false;
        if (!params.global) {
            const local = this.localStores[params.store];
            if (local) {
                foundLocal = true;
                delete this.localStores[params.store];
                local.destroy();
            }
        }
        if (!foundLocal) {
            const st = new RemoteStore(this.glue, { store: params.store, global: params.global, values: null });
            await new Promise((resolve) => { st.destroy(() => { resolve(); }); });
        }
        this.logStatus("removeStore", "return", { err: null, data: true });
        cb?.(null, true);
        return {
            err: null,
            data: true,
        };
    }
    async getOrCreateStoreObject(params) {
        await this.asyncConstructors.ready();
        const isGlobal = params.global;
        const values = typeof (params.values) === "object" ? deepmerge({}, params.values) : params.values;
        if (isGlobal) {
            const store = new RemoteStore(this.glue, { store: params.store, global: params.global, values });
            await store.init();
            return store;
        }
        else {
            let store = this.localStores[params.store];
            if (!store) {
                store = new LocalStore(this.glue, { store: params.store, values });
                store.getGlobalValue = async (p, cb) => {
                    const remoteStore = await this.getOrCreateStoreObject({ store: p.store, global: true });
                    return remoteStore.getGlobalValue(p, cb);
                };
                await store.init();
                this.localStores[params.store] = store;
            }
            return store;
        }
    }
}
